import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as actions from '../../actions/actions.jsx';
import '../../stylesheet/tabdesign.css';
import LeftLink from '../leftlink/leftlink.jsx';
import AuthNavbar from '../navigation/authnavigation.jsx';
import CardPreferance from './cardpreferance.jsx';
import ChangePassword from './changepassword.jsx';
import ManagePin from './managepin.jsx';
import Messages from './messages.jsx';
import PersonalInfo from './personalinfo.jsx';
const mapStateToProps = state =>
    ({
        optionState: state.selectedTabReducer.selectedTabReducer,
        cardState: state.getCardReducer.cardState,
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchSelectedTab(selectedOption) {
            dispatch(
                actions.selectedtabAction(selectedOption)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
    })

class MyProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedOption: localStorage.getItem('taboption') || "tab1"
        }
    }
    handleChange(e) {
        this.setState({
            selectedOption: e.target.value
        })
    }
    componentWillMount() {
        this.props.fetchSelectedTab(this.state.selectedOption)
    }
    componentDidMount() {
        localStorage.setItem("comp", "profilecomp")
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
     
    //     let _this = this
    //     setTimeout(function () {
    //         if (publicKey.status === 200) {
    //             const public_Key = publicKey.body.publickey;
    //             let encrypt = new JSEncrypt();
    //             encrypt.setPublicKey(public_Key);


    //             const state = {
    //                 applicationId: localStorage.getItem('pform') === 'AU' ? 'klickexau' : 'klickex',
    //                 accountId: encrypt.encrypt(localStorage.getItem("accountId"))
    //             }
    //             _this.props.fetchCard(state)

    //         }
    //     }, 500);


     }
    // componentWillReceiveProps(nextProps) {
    //     try {
    //         if (nextProps.cardState && nextProps.cardState.length !== 0) {
    //             var filteredR = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "R")
    //             })
    //             var filteredG = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "G")
    //                 
    //             })
    //             var filteredA = nextProps.cardState.body.filter((val) => {
    //                 return (val.cardType === "A")
    //                 
    //             })

    //             var filteredCards = filteredR.concat(filteredG)
    //             this.setState({
    //                 filteredCards: filteredCards[0].cardType
    //             }, () => {
    //                
    //             })
    //         }
    //     } catch (e) {

    //     }

    // }
    callBack() {
        this.setState({
            selectedOption: localStorage.getItem('taboption')
        })
    }

    render() {      
       
        
        var cardTypes = localStorage.getItem('cardTypes')
        
        // const { filteredCards } = this.state
        // 
      
        return (
            <div  className="row">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnVisibilityChange
                draggable
                pauseOnHover
            />            

                    <div className="col-md-12 m-0 p-0">
                        <AuthNavbar />
                    </div>


                <div className="container" style={{ }}>
                    <div className="row pb-5">
                    <PersonalInfo />
                        {/* <div className="col-sm-3 box-shadow-style nopadding">
                            <LeftLink callBackFromParent={this.callBack.bind(this)} />
                        </div> */}

                        {/* <div className="col-sm-9" style={{ padding: "0px 30px" }}>
                            <div className="row box-shadow-style" style={{ padding: "0px 0px", minHeight: "476px" }}>
                                <div className="pc-tab">
                                    <input id="tab1" type="radio" name="pct" value="tab1" checked={this.state.selectedOption === 'tab1'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab2" type="radio" name="pct" value="tab2" checked={this.state.selectedOption === 'tab2'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab3" type="radio" name="pct" value="tab3" checked={this.state.selectedOption === 'tab3'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab4" type="radio" name="pct" value="tab4" checked={this.state.selectedOption === 'tab4'} onChange={this.handleChange.bind(this)} />
                                    <input id="tab5" type="radio" name="pct" value="tab5" checked={this.state.selectedOption === 'tab5'} onChange={this.handleChange.bind(this)} />
                                    <nav>
                                        
                                        {(cardTypes.includes('R') ) ?
                                         <ul>
                                                <li className="tab1">
                                                    <label style={{ cursor: "pointer", }} htmlFor="tab1">Manage Profile</label>
                                                </li>
                                                <li className="tab2">
                                                    <label style={{ cursor: "pointer",}} htmlFor="tab2">Password / Secret Q&A</label>
                                                </li>
                                                <li className="tab3">
                                                    <label style={{ cursor: "pointer" }} htmlFor="tab3">Card Preferences</label>
                                                </li>
                                                <li className="tab4">
                                                    <label style={{ cursor: "pointer",}} htmlFor="tab4">Change PIN</label>
                                                </li>

                                               
                                            </ul>
                                            
                                        :
                                        (cardTypes.includes('G')) ?

                                            <ul>
                                                <li className="tab1">
                                                    <label style={{ cursor: "pointer"}} htmlFor="tab1">Manage Profile</label>
                                                </li>
                                                <li className="tab2">
                                                    <label style={{ cursor: "pointer"}} htmlFor="tab2">Password / Secret Q&A</label>
                                                </li>
                                                <li className="tab3">
                                                    <label style={{ cursor: "pointer"}} htmlFor="tab3">Card Preferences</label>
                                                </li>
                                                <li className="tab4">
                                                    <label style={{ cursor: "pointer",}} htmlFor="tab4">Change PIN</label>
                                                </li> 
                                             
                                             </ul>
                                          :
                                           (cardTypes.includes('A')) ?
                                         <ul>
                                                <li className="tab1">
                                                    <label style={{ cursor: "pointer", width: "34%" }} htmlFor="tab1">Manage Profile</label>
                                                </li>

                                                <li className="tab2">
                                                    <label style={{ cursor: "pointer", width: "34%" }} htmlFor="tab2">Password / Secret Q&A</label>
                                                </li>
                                                <li className="tab3">
                                                    <label style={{ cursor: "pointer", width: "33%"}} htmlFor="tab3">Card Preferences</label>
                                                </li>
                                            </ul>
                                            :
                                            null
                                          
                                        }
                                    </nav>
                                    <section>
                                        <div className="tab1">
                                            <PersonalInfo />
                                        </div>
                                        <div className="tab2">
                                            <ChangePassword />
                                        </div>
                                      
                                        <div className="tab3">
                                            <CardPreferance />
                                        </div>
                                        <div className="tab4">
                                            <ManagePin />
                                        </div>
                                        <div className="tab5">
                                            <Messages />
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div> */}
                        
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);


// WEBPACK FOOTER //
// ./src/components/myprofile/myprofile.jsx